import { render } from "./TaskDialog.vue?vue&type=template&id=e6dbfeda&scoped=true"
import script from "./TaskDialog.vue?vue&type=script&lang=js"
export * from "./TaskDialog.vue?vue&type=script&lang=js"

import "./TaskDialog.vue?vue&type=style&index=0&id=e6dbfeda&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6dbfeda"]])

export default __exports__